import React from 'react';
import { CompanyRole, CompanyRoleAssignment } from '../types/company_role_assignment/companyRoleAssignment';

export interface CompanyRoleAssignmentContextProps {
  /* By user id */
  companyRoles: Map<string, CompanyRoleAssignment[]>;
  setCompanyRoles: (roles: Map<string, CompanyRoleAssignment[]>) => void;
  refreshCompanyRoles: () => Promise<void>;
  currentCompanyRole: (companyId: string) => CompanyRole | undefined;
  hasCompanyRole: (companyId: string, role: CompanyRole) => boolean;
  hasRole: (role: CompanyRole) => boolean;
  isAdmin: boolean;
}

const defaultContext: CompanyRoleAssignmentContextProps = {
  companyRoles: new Map(),
  setCompanyRoles: roles => {},
  refreshCompanyRoles: async () => {},
  currentCompanyRole: () => undefined,
  hasCompanyRole: () => false,
  hasRole: () => false,
  isAdmin: false,
};

export const CompanyRoleAssignmentContext = React.createContext<CompanyRoleAssignmentContextProps>(defaultContext);
